import "around/dist/vendor/lightgallery.js/dist/css/lightgallery";
require("around/dist/vendor/lightgallery.js/dist/js/lightgallery");
global.lgFullScreen = require("around/dist/vendor/lg-fullscreen.js/dist/lg-fullscreen.min.js");
global.lgZoom = require("around/dist/vendor/lg-zoom.js/dist/lg-zoom.min.js");